import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { useRouter } from "src/hooks/useRouter";
import { useAuth } from "src/hooks/useAuth";
import Sidebar from "components/Console/Sidebar/Sidebar.container";
import HeaderContainer from "components/Header/_Header.container";
import { isShowSideBarAtom, productKeyAtom, userInfoAtom } from "src/atoms";
import Footer from "components/Footer";
import ConsoleModalsProvider from "src/context/Modal/Console/ConsoleModal.provider";
import { useGetMyServiceList } from "src/hooks/api/product/useGetMyServiceList";
import MyAccountModalsProvider from "src/context/Modal/MyAccount/MyAccountModal.provider";
// import { languageRouteInit } from "src/utils/localization";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import "./AuthLayout.style.scss";
import BillModalsProvider from "src/context/Modal/Bill/BillModal.provider";
import { useIsOpenSelectProduct } from "src/hooks/recoil/useIsOpenSelectProduct";
import Home from "src/pages/Home";
import { useCheckHasBill } from "src/hooks/validation/useCheckHasBill";
import { Button } from "react-bootstrap";

interface GeneralLayoutProps {
  children: React.ReactNode;
  isAdminPage?: boolean;
  isFooter?: boolean;
}

// 로그인한 사용자만 접근 가능
const AuthLayout: React.FC<GeneralLayoutProps> = ({
  children,
  isAdminPage,
  isFooter,
}) => {
  {
    /* TODO 4-2: Recoil atom `UserAtom`을 이용해 userProfile props 대체 및 삭제 */
  }
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const route = useRouter();
  const [isShowSideBar] = useRecoilState(isShowSideBarAtom);
  const headerRef = useRef<HTMLDivElement>(null);

  const [contentHeight, setContentHeight] = useState<number>(0);
  const { isOpenSelectProduct, setIsOpenSelectProduct } =
    useIsOpenSelectProduct();
  const { isMyServiceLoading, serviceList } = useGetMyServiceList({});
  const { cloudUserInfo } = useAuth();
  const [productKey, setroductKey] = useRecoilState(productKeyAtom);
  const { isOciProduct } = useProductFlags();
  // const isWrapsodyEco = useIsWrapsodyEcoProduct();
  // const { unregisterPayList } = useGetPayUnregisterBill({});
  // const { unregisterPromotionList } = useGetPromotionUnregisterBill({});
  // const [searchParams, setSearchParams] = useSearchParams();

  // 페이지 이동 시 제품선택 오버레이 접기.
  // 열린 채로 이동하면 라우트와 무관하게 <Home />이 렌더링되어 이동한 페이지가 보이지 않는다.
  // pathname이 아니라 location.key를 보는 이유: 현재 페이지와 같은 경로로 이동하는 경우
  // (예: /service/list에서 "나의 클라우드 서비스" 클릭) pathname은 그대로라 감지되지 않는다.
  const { key: locationKey } = useLocation();
  useEffect(() => {
    setIsOpenSelectProduct(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationKey]);

  useEffect(() => {
    const cloudUserInfo = JSON.parse(
      localStorage.getItem("cloudUserInfo") as string,
    );
    if (cloudUserInfo?.userInfo) {
      setUserInfo({ ...cloudUserInfo?.userInfo });
    }
    // if (isLanguageRouteInit) languageRouteInit();
    // if (searchParams.get("resultMsg")) {
    //   alert(searchParams.get("resultMsg"));
    // }
  }, []);
  // 구매한 사이트가 있는지 확인하는 Hook
  // useCheckHasBill();
  // const fetchUserInfo = useCallback(async () => {
  //   const userInfoResponse = await checkUserId({}); // 유저 세션 확인

  //   if (userInfoResponse === null) {
  //     routeTo("/login");
  //     return;
  //   }

  //   {
  //     /* TODO 4-2: Recoil atom `UserAtom`을 이용해 setUserProfile props 대체 및 삭제 */
  //   }
  //   setUserInfo(userInfoResponse);
  // }, []);

  // TODO 4-1: 응답으로 받은 user의 userInfo.roles가 비어있다면 아무 권한이 없는 user이므로 로그인 페이지로 이동
  // if (userInfo?.roles.length === 0) {
  //   routeTo("/login");
  //   return <></>;
  // }

  // // TODO 4-1: Admin 전용 페이지 접근 시도시 userProfile.userInfo.roles에 admin이 없는 경우에는 page-a로 이동
  // if (isAdminPage && !userInfo?.roles.includes(AdminRole)) {
  //   routeTo("/page-a");
  //   return <></>;
  // }

  // if (!hasSite && route.currentPath.includes("console")) return <div></div>;
  // if (isLoading) return <>Loading...</>;
  // 헤더 높이를 재서 본문 높이(calc(100vh - 헤더))를 정한다.
  // useEffect면 measure 전 첫 페인트가 contentHeight=0(=본문 100vh)로 그려져
  // 헤더 높이만큼 문서가 넘쳐 스크롤바가 한 프레임 깜빡인다. → 페인트 전에 측정.
  useLayoutEffect(() => {
    const handleResize = () => {
      // console.log(
      //   "headerRef",
      //   headerRef.current,
      //   headerRef.current?.offsetHeight
      // );
      headerRef.current?.offsetHeight &&
        setContentHeight(headerRef.current.offsetHeight);

      // tableRef.current?.offsetWidth &&
      //   setTableWidth(tableRef.current?.clientWidth);
      // console.log("tableRef", tableRef.current?.offsetHeight);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // if (tableRef.current?.offsetHeight) {
    //   setScrollHeight(tableRef.current?.offsetHeight - 50);
    // }
  }, [route, productKey]);
  const fullHeightPathList = [
    "/site/type",
    "/site/pay",
    "/site/promotion",
    "/service/list",
  ];
  function isFullHeight() {
    if (isOpenSelectProduct) return true;
    else
      return fullHeightPathList.some((path) =>
        window.location.pathname.includes(path),
      );
  }
  if (!cloudUserInfo) return <></>;
  const tab = "common";
  return (
    <ConsoleModalsProvider>
      <MyAccountModalsProvider>
        <BillModalsProvider>
          <div className="general-layout">
            {/* TODO 4-2: Recoil atom `UserAtom`을 이용해 userProfile props 대체 및 삭제 */}
            {/* <Sidebar sidebarContent={SidebarContent} /> */}

            <>
              {!isOciProduct && <HeaderContainer headerRef={headerRef} />}
              {!isMyServiceLoading && (
                <>
                  <div
                    className="general-layout__body"
                    style={{
                      height: isFullHeight()
                        ? "100%"
                        : `calc(100vh - ${contentHeight}px)`,
                      flexDirection: `${isAdminPage ? "row" : "column"}`,
                    }}
                  >
                    {/* {isAdminPage && hasBill && <Sidebar />} */}
                    {isAdminPage &&
                      // isShowSideBar &&
                      // unregisterPayList?.length === 0 &&
                      // unregisterPromotionList?.length === 0 &&
                      // userCashStatus?.status === "DONE" &&
                      serviceList?.length === 1 &&
                      !isOpenSelectProduct && <Sidebar />}
                    {/* {isOciProduct
                      ? isAdminPage && hasBill && !isWrapsodyEco && <Sidebar />
                      : isAdminPage && hasBill && <Sidebar />} */}
                    {isOpenSelectProduct ? <Home /> : children}
                  </div>
                </>
              )}
            </>
            {isFooter && <Footer />}
            <div
              style={{
                display:
                  userInfo?.userId === "dongdev2@fasoo.com" ? "block" : "none",
              }}
            >
              <Button
                onClick={async () => {
                  try {
                    const params = new URLSearchParams({
                      majorDimension: "ROWS",
                      range: `${tab}!D1:G`,
                      tabName: `${tab}`,
                    });
                    const res = await fetch(
                      `/api/locale-sync?${params.toString()}`,
                    );
                    const json = await res.json();
                    // eslint-disable-next-line no-console
                    console.log("locale-sync:", json);
                    alert(
                      json.ok
                        ? "리소스 동기화 완료(새로고침 후 적용)"
                        : `실패: ${json.error}`,
                    );
                  } catch (e: any) {
                    alert(`Failed: ${e?.message || String(e)}`);
                  }
                }}
              >
                리소스 동기화
              </Button>
            </div>
          </div>
        </BillModalsProvider>
      </MyAccountModalsProvider>
    </ConsoleModalsProvider>
  );
};

export default AuthLayout;
